import React, { useEffect, useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import CountDownTimerComponent from '../components/CountDownTimerComponent';
import axios from 'axios';
import { loginSuccess, logout } from '../slices/authSlice';
import { selectAuth } from '../slices/authSlice';
import { useSelector, useDispatch } from 'react-redux'

import Book from '../components/Book'

function BookPage() {
  const { isAuthenticated, userInformation } = useSelector(selectAuth);

  const [longvp, setLongvp] = useState(window.innerHeight)
  const [shortvp, setShortvp] = useState(window.innerWidth)


  useEffect(
    () => {
      console.log(window.innerWidth)
      if (window.innerHeight > window.innerWidth) {
        setLongvp(window.innerHeight)
        setShortvp(window.innerWidth)
      }
      else {
        setShortvp(window.innerHeight)
        setLongvp(window.innerWidth)
      }
    },
    window.innerWidth
  );

  const handleClick = () => {
    console.log(`long: ${longvp}`)
    console.log(`short: ${shortvp}`)
  };

  // Function to handle test button click
  const handleTestButtonClick = async () => {
    try {
      const response = await axios.get('/api/test'); // Call the /test endpoint
      console.log('Test Response:', response.data); // Log the response data
    } catch (error) {
      console.error('Error calling /api/test:', error); // Log any errors
    }
  };


  const [loadingPages, setLoadingPages] = useState(true);
  const [pages, setPages] = useState([])

  useEffect(() => {
    const fetch = async () => {
      try {
        const response = await axios.get('/api/defis');
        if (response.status == 200) {
          console.log(response.data)
          setPages(response.data)
        }
      } catch (error) {
        console.error('Error:', error);
        // Handle error appropriately, e.g., show an error message or dispatch a failure action
      } finally {
        setLoadingPages(false)
      }

    };
    fetch();
  }, []);

  return (
    <Container>
      <Row className="text-center my-4">
        <Col>
          <h2 style={{
            fontSize: '3rem', // Large font size
            fontWeight: 'bold', // Bold text
            textShadow: '2px 2px 4px black', // Drop shadow
            color: '#000', // Text color
          }}>
            Rallye National <br />
            Branche Éclaireurs <br />
            2025
          </h2>
        </Col>
      </Row>
      <Container className="shadow p-2" fluid><CountDownTimerComponent timeTillDate="07 04 2025, 09:00 am" timeFormat="MM DD YYYY, h:mm a" /></Container>

      {isAuthenticated ?
        (
          <Row className="py-4">
            <Col xs={12} lg={8} className="shadow p-2">
              <div className="text-center">
                <h1>{userInformation.groupe}</h1>
                {userInformation.troupe ? <h2>{userInformation.troupe}</h2> : <></>}
                <h2>{userInformation.patrouille}</h2>
              </div>
            </Col>
          </Row>
        )
        :
        (<div></div>)
      }
      <Row className="py-3">
      <Col xs={12}>
          <div className="text-center">
            <h1>Les Defis</h1>
          </div>
        </Col>
      </Row>
      <Row className="shadow m-2">
        
        <Col xs={12} lg={8} className="p-2">
          {loadingPages ? <p>Loading...</p> : <Book pages={pages} />}
        </Col>
        <Col lg={2}>
          {/* <Button variant="secondary" onClick={handleTestButtonClick} className="my-2">
            Test
          </Button> */}
        </Col>

      </Row>
    </Container>
  );
}

export default BookPage;